import React, { Context, createContext, FC, ReactElement } from 'react'
import { BasicContextProps } from '../../Common/Types/Types'
import Config from '../Config'

// Create the type based on the config.
export type SelfProvisioningConfig = typeof Config

export const SelfProvisioningConfigContext: Context<SelfProvisioningConfig> =
    createContext<SelfProvisioningConfig>(Config)

export const SelfProvisioningConfigContextProvider: FC<BasicContextProps> = ({
    children
}: BasicContextProps): ReactElement => (
    <SelfProvisioningConfigContext.Provider value={Config}>{children}</SelfProvisioningConfigContext.Provider>
)
